import { defineComponent as _defineComponent } from 'vue'
import ShopWallItem from '@/components/redeem/shop-wall/ShopWallItem.vue';
import { ShopDetails } from '~model';


export default /*#__PURE__*/_defineComponent({
  __name: 'AvailabilityWarning',
  props: {
  shop: {
    type: Object as () => ShopDetails,
    required: true,
  },
  alternativeShops: {
    type: Array as () => ShopDetails[] || null,
    required: true,
  },
},
  setup(__props) {




return { __sfc: true,ShopWallItem }
}

})